const NEWSLETTER_BRAND_URL = "https://newsletter.euroweb.net/service/newsletter.php";
let brand = null;
let getNewsletterBrandedUrl = function () {
  if (brand) {
    return brand;
  }
  let cmsModuleScriptEl = document.querySelector("script[data-website-brand]");
  if (cmsModuleScriptEl) {
    brand = `https://newsletter.${cmsModuleScriptEl.getAttribute("data-website-brand")}/service/newsletter.php`;
    return brand;
  }
};
export { getNewsletterBrandedUrl };